const TEST_IDS = {
  supplyInfo: 'market-details-supply-info',
  borrowInfo: 'market-details-borrow-info',
  interestRateModel: 'market-details-interest-rate-model',
  marketInfo: 'market-details-market-info',
};

export default TEST_IDS;
